export default __webpack_public_path__ + "static/media/cardLoading.b3889c62.svg";